import React from "react";
import { CarrierHelper } from "src/helpers";

interface TrackingLinkProps {
  trackingNo: string;
  carrier?: string;
  collectionOrder?: boolean;
}

const TrackingLink: React.FC<TrackingLinkProps> = ({ trackingNo, carrier, collectionOrder }) => {
  const trackingUrl = CarrierHelper.resolveCarrierTrackingURL(trackingNo, carrier, collectionOrder);

  return trackingUrl ? (
    <a
      className="text-black bg-white font-normal text-base border-0 outline-none rounded-none border-b border-black p-0 pb-0.5 no-underline hover:cursor-pointer disabled:text-gray-400 disabled:border-b-gray-400 disabled:cursor-auto"
      href={trackingUrl}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none", color: "inherit" }}
    >
      {trackingNo}
    </a>
  ) : (
    trackingNo
  );
};

export { TrackingLink };
